import {TranslationProvider, Translation} from "src/components/translation";

import Login from "./Login";

const strings = require<Translation>('./strings.yaml');


export default () => <TranslationProvider translation={strings}>
  <Login/>
</TranslationProvider>;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/routes/login/index.tsx